<template>
  <div class="pt-4">
    <div @click="navigateToServiceBookOverallView()" style="cursor: pointer;">
      <b-icon icon="chevron-left"></b-icon>&nbsp;Zurück
    </div>

    <b-card header-tag="h5" class="mb-3 mt-4">
      <div class="card-header bg-danger text-white">
        <b-skeleton-wrapper :loading="loading">
          <template #loading>
            <b-skeleton width="100%"></b-skeleton>
          </template>
          Datum: {{ formattedDate }}
        </b-skeleton-wrapper>
      </div>
      <b-list-group flush class="mb-3">
        <b-list-group-item>
          <strong>Diensthabender Startleiter:</strong>
          <multiselect
            v-model="entryStartManager"
            :options="licensedPilots"
            :searchable="true"
            :close-on-select="true"
            :show-labels="false"
            placeholder="Person auswählen..."
          ></multiselect>
        </b-list-group-item>
        <b-list-group-item>
          <strong>Fluglehrer:</strong>
          <multiselect
            v-model="entryFlightInstructor"
            :options="flightInstructors"
            :searchable="true"
            :multiple="true"
            :close-on-select="true"
            :show-labels="false"
            placeholder="Person auswählen..."
          ></multiselect>
        </b-list-group-item>
        <b-list-group-item>
          <strong>Windenfahrer:</strong>
          <multiselect
            v-model="entryWinchDriver"
            :options="licensedPilots"
            :searchable="true"
            :close-on-select="true"
            :show-labels="false"
            placeholder="Person auswählen..."
          ></multiselect>
        </b-list-group-item>
        <b-list-group-item>
          <strong>Starthelfer:</strong>
          <multiselect
            v-model="entryStartHelper"
            :options="students"
            :searchable="true"
            :close-on-select="true"
            :show-labels="false"
            placeholder="Person auswählen..."
          ></multiselect>
        </b-list-group-item>
        <b-list-group-item>
          <strong>Innendienst:</strong>
          <multiselect
            v-model="entryIndoorService"
            :options="users"
            :searchable="true"
            :close-on-select="true"
            :show-labels="false"
            placeholder="Person auswählen..."
          ></multiselect>
        </b-list-group-item>
        <b-list-group-item>
          <strong>Seil-KFZ:</strong>
          <multiselect
            v-model="entryRopeVehicleDriver"
            :options="users"
            :searchable="true"
            :close-on-select="true"
            :show-labels="false"
            placeholder="Person auswählen..."
          ></multiselect>
        </b-list-group-item>
        <b-list-group-item>
          <strong>Rückhol-KFZ:</strong>
          <multiselect
            v-model="entryReturnVehicleDriver"
            :options="users"
            :searchable="true"
            :close-on-select="true"
            :show-labels="false"
            placeholder="Person auswählen..."
          ></multiselect>
        </b-list-group-item>
        <b-list-group-item>
          <strong>Aufgaben:</strong>
          <b-form-textarea
            v-model="entryTasks"
            id="textarea_tasks"
            placeholder="Aufgaben eintragen..."
            rows="3"
            max-rows="6"
          ></b-form-textarea>
        </b-list-group-item>
        <b-list-group-item>
          <strong>Technik:</strong>
          <multiselect
            v-model="entryTechnique"
            :options="techniqueOptions"
            :searchable="false"
            :multiple="true"
            :close-on-select="false"
            :show-labels="false"
            placeholder="Technik auswählen..."
          ></multiselect>
        </b-list-group-item>
        <b-list-group-item>
          <strong>Schüleraufteilung:</strong>
          <b-form-textarea
            v-model="entryStudentAllocation"
            id="textarea_student_allocation"
            placeholder="Aufteilung eintragen..."
            rows="3"
            max-rows="6"
          ></b-form-textarea>
        </b-list-group-item>
        <b-list-group-item>
          <strong>Gästeflüge:</strong>
          <b-form-checkbox v-model="entryGuestFlights"></b-form-checkbox>
        </b-list-group-item>
        <b-list-group-item>
          <strong>Sind alle in der Lage?</strong>
          <b-form-checkbox v-model="entryEveryoneAble"></b-form-checkbox>
        </b-list-group-item>
        <b-list-group-item>
          <strong>Mängel:</strong>
          <b-form-textarea
            v-model="entryDefects"
            id="textarea_defects"
            placeholder="Mängel eintragen..."
            rows="3"
            max-rows="6"
          ></b-form-textarea>
        </b-list-group-item>
        <b-list-group-item>
          <strong>Kasse:</strong>
          <b-input-group>
            <b-input-group-prepend>
              <b-button
                disabled
                variant="outline-secondary"
                style="
                  border-radius: 0.375rem 0 0 0.375rem;
                  border-color: #dee2e6;
                "
              >
                <b-icon icon="currency-euro"></b-icon>
              </b-button>
            </b-input-group-prepend>
            <b-form-input v-model="entryCash"></b-form-input>
          </b-input-group>
        </b-list-group-item>
        <b-list-group-item>
          <strong>Nicht angetretene Dienste:</strong>
          <b-form-textarea
            v-model="entryNotPerformedServices"
            id="textarea_not_performed_services"
            placeholder="Nicht angetretene Dienste eintragen..."
            rows="3"
            max-rows="6"
          ></b-form-textarea>
        </b-list-group-item>
        <b-list-group-item>
          <strong>Sonstige Anmerkungen:</strong>
          <b-form-textarea
            v-model="entryNotes"
            id="textarea_notes"
            placeholder="Sonstige Anmerkungen eintragen..."
            rows="3"
            max-rows="6"
          ></b-form-textarea>
        </b-list-group-item>
      </b-list-group>

      <strong>Unterschrift:</strong>
      <div>
        <VueSignaturePad
          id="signature"
          width="100%"
          height="14vh"
          ref="signaturePad"
          :options="options"
          :class="{ highlight: isHighlighted }"
        />
      </div>
    </b-card>
    <div class="buttons m-3">
      <b-button variant="danger" @click="save"
        >Speichern & Flugbetrieb starten?</b-button
      >
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Multiselect from "vue-multiselect";

export default {
  components: { Multiselect },
  data() {
    return {
      options: {
        penColor: "#008",
      },

      entryStartManager: null,
      entryFlightInstructor: null,
      entryWinchDriver: null,
      entryStartHelper: null,
      entryIndoorService: null,
      entryRopeVehicleDriver: null,
      entryReturnVehicleDriver: null,
      entryTasks: null,
      entryTechnique: null,
      entryStudentAllocation: null,
      entryGuestFlights: false,
      entryEveryoneAble: false,
      entryDefects: null,
      entryCash: null,
      entryNotPerformedServices: null,
      entryNotes: null,

      currentDate: null,
      formattedDate: null,
      isActive: false,

      loading: false,

      techniqueOptions: [
        "PZL Bielsko SZD-50 Puchacz (4622)",
        "PZL Bielsko SZD-50 Puchacz (5660)",
        "Schleicher ASW19",
        "Schleicher ASW24",
        "Hoffmann HK36 Dimona",
        "Winde H4",
        "Winde H5",
      ],

      flightInstructors: [],
      licensedPilots: [],
      students: [],
      users: [],

      startingService: true,
      serviceBookEntryStarted: false,

      isHighlighted: false,

      apiUrl: process.env.VUE_APP_API_URL,
    };
  },

  methods: {
    navigateToServiceBookOverallView() {
      this.$router.push(`/flight-operations/service-book/overall`);
    },

    highlightSignaturePad() {
      this.isHighlighted = true;
      setTimeout(() => {
        this.isHighlighted = false;
      }, 4000);
    },
    
    save() {
      const { isEmpty, data } = this.$refs.signaturePad.saveSignature();

      const Toast = this.$swal.mixin({
        toast: true,
        position: "top",
        showConfirmButton: false,
        timer: 4000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });

      if (isEmpty) {
        Toast.fire({
          icon: "warning",
          title:
            "Deine Unterschrift wird noch benötigt. Bitte unterschreibe direkt im dafür vorgesehenen Feld.",
        });
        this.highlightSignaturePad();
        return;
      }

      const body = {
        date: this.currentDate,
        startManager: this.entryStartManager,
        flightInstructor: this.entryFlightInstructor,
        winchDriver: this.entryWinchDriver,
        startHelper: this.entryStartHelper,
        indoorService: this.entryIndoorService,
        ropeVehicleDriver: this.entryRopeVehicleDriver,
        returnVehicleDriver: this.entryReturnVehicleDriver,
        tasks: this.entryTasks,
        technique: this.entryTechnique,
        studentAllocation: this.entryStudentAllocation,
        guestFlights: this.entryGuestFlights,
        everyoneAble: this.entryEveryoneAble,
        defects: this.entryDefects,
        cash: this.entryCash,
        notPerformedServices: this.entryNotPerformedServices,
        notes: this.entryNotes,
        signature: data,
      };

      axios
        .post(this.apiUrl + "/service-book/post-new-entry", body)
        .then((response) => {
          console.log(response.data);

          this.startingService = !this.startingService;
          this.serviceBookEntryStarted = !this.serviceBookEntryStarted;

          this.isActive = true;

          Toast.fire({
            icon: "success",
            title: "Flugbetrieb gestartet",
            text: "Guten Flug!",
          });
          this.$router.push("/flight-operations");
        });
    },

    async getOptions() {
      return new Promise((resolve) => {
        axios
          .get(this.apiUrl + "/service-book/get-options")
          .then((response) => {
            this.flightInstructors = response.data.users.flight_instructors;
            this.licensedPilots = response.data.users.licensed_pilots;
            this.students = response.data.users.students;
            this.users = response.data.users.users;

            this.currentDate = response.data.date.currentDate;
            this.formattedDate = response.data.date.formattedDate;

            this.isActive = response.data.isActive;

            resolve();
          })
          .catch((error) => {
            console.error("Error fetching data:", error);

            if (error.status === 401) {
              localStorage.removeItem("token");
            }

            resolve();
          });
      });
    },

    async getEntry() {
      return new Promise((resolve) => {
        axios
          .get(this.apiUrl + "/service-book/get-entry?date=" + this.currentDate)
          .then((response) => {
            this.entryStartManager = response.data.startManager;
            this.entryFlightInstructor = response.data.flightInstructor;
            this.entryWinchDriver = response.data.winchDriver;
            this.entryStartHelper = response.data.startHelper;
            this.entryIndoorService = response.data.indoorService;
            this.entryRopeVehicleDriver = response.data.ropeVehicleDriver;
            this.entryReturnVehicleDriver = response.data.returnVehicleDriver;
            this.entryTasks = response.data.tasks;
            this.entryTechnique = response.data.technique;
            this.entryStudentAllocation = response.data.studentAllocation;
            this.entryGuestFlights = response.data.guestFlights;
            this.entryEveryoneAble = response.data.everyoneAble;
            this.entryDefects = response.data.defects;
            this.entryCash = response.data.cash;
            this.entryNotPerformedServices = response.data.notPerformedServices;
            this.entryNotes = response.data.notes;

            resolve();
          })
          .catch((error) => {
            console.error("Error fetching data:", error);

            if (error.status === 401) {
              localStorage.removeItem("token");
            }
            resolve();
          });
      });
    },

    async initEntry() {
      await this.getOptions();
      await this.getEntry();
    },
  },

  beforeMount() {
    this.loading = true;

    this.initEntry();

    this.loading = false;
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>
.text-center {
  text-align: center;
}

#signature {
  border-top: solid 1px #dee2e6;
  border-radius: 0 0 0.375rem 0.375rem;
}

.card-body {
  padding: 0 !important;
}

.highlight {
  animation: blinkAnimation 1.5s infinite;
}
@keyframes blinkAnimation {
  0% {
    border-color: rgb(255, 145, 0);
  }
  50% {
    border-color: #dee2e6;
  }
  100% {
    border-color: rgb(255, 145, 0);
  }
}
</style>
